import { render, staticRenderFns } from "./PoliciesListTable.vue?vue&type=template&id=3a0a6a4c&scoped=true&"
import script from "./PoliciesListTable.vue?vue&type=script&lang=js&"
export * from "./PoliciesListTable.vue?vue&type=script&lang=js&"
import style0 from "./PoliciesListTable.vue?vue&type=style&index=0&id=3a0a6a4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0a6a4c",
  null
  
)

export default component.exports